import { createContext, useContext } from 'react';
import { JazzRoom, JazzSdk } from '@salutejs/jazz-sdk-web';

interface IRoomContext {
  user: unknown,
  order: unknown,
  room: JazzRoom | unknown,
  sdk: JazzSdk | unknown
}

const initialContext = {
  user: {},
  order: {},
  room: {},
  sdk: {}
};
export const RoomContext = createContext<IRoomContext>(initialContext);

export function useRoomContext() {
  const context = useContext<IRoomContext>(RoomContext);
  if (!context) {
    throw new Error('RoomContext is required');
  }
  return context;
}
